import React, { useState } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import ContentGenQuizContainer from "./ContentGenQuizContainer";
import ContentGenResults from "./ContentGenResults";
import UserInfoForm, { UserInfo } from "../../components/UserInfoForm";

export interface ContentGenResult {
  questionId: number;
  selectedOption: number;
  scores: {
    contentCreation: number;
    automation: number;
    quality: number;
  };
}

const ContentGenQuiz: React.FC = () => {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);

  const handleUserInfoSubmit = (userData: UserInfo) => {
    setUserInfo(userData);
    navigate("quiz");
  };

  return (
    <Routes>
      <Route
        index
        element={
          <UserInfoForm
            onSubmit={handleUserInfoSubmit}
            subtitle="Transform Your Content Creation Process"
          />
        }
      />
      <Route
        path="quiz"
        element={<ContentGenQuizContainer userInfo={userInfo} />}
      />
      <Route path="results" element={<ContentGenResults />} />
      <Route path="*" element={<Navigate to="/contentgen" replace />} />
    </Routes>
  );
};

export default ContentGenQuiz;
